import { AccordionPosition, AccordionButton } from 'remote-com-shared/components/Accordion';
import styled, { css } from 'styled-components';

import BookIcon from './assets/book-purple.svg';

import { FAQSection } from '@/src/components/FrequentlyAskedQuestions';
import { transformProperties } from '@/src/domains/prismic/helpers';
import { defaultHtmlSerializer } from '@/src/domains/prismic/render';
import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';
import {
  FAQAccordionHeader,
  FAQRichTextWrapper,
  FAQTitleComponent,
} from '@/src/views/ContractorManagement/styles';

export const SectionWrapper = styled(FAQSection)`
  && {
    padding-top: 100px;
    position: relative;
    background: #f8f5ff;
    font-family: var(--typography-fontBossa);
    z-index: 1;

    ${FAQRichTextWrapper} {
      font-family: var(--typography-fontBrand);
      padding-left: 43px;

      ${tabletBreakpoint(css`
        padding-left: 40px;
      `)}
    }

    ${FAQAccordionHeader} {
      ${AccordionPosition} {
        color: #5700ff;
        border: none;
        margin-right: 22px;

        &::before {
          content: '0';
        }
      }
    }

    ${AccordionButton} {
      align-items: baseline;
    }
  }

  ${FAQTitleComponent} {
    text-align: left;
  }
`;

const IconWrapper = styled.div`
  margin-bottom: 20px;
`;

export function FAQSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, ctaLink, ctaLabel } = primary;
  const { fields: frequentlyAskedQuestions } = slice;

  return (
    <SectionWrapper
      title={title}
      ctaLink={ctaLink}
      ctaLabel={ctaLabel}
      icon={
        <IconWrapper>
          <BookIcon />
        </IconWrapper>
      }
      frequentlyAskedQuestions={frequentlyAskedQuestions}
      htmlSerializer={defaultHtmlSerializer}
    />
  );
}
